// extracted by mini-css-extract-plugin
export default {"multilineText":"Controls_multilineText__IAvmE"};